import React, { useState, useEffect} from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import { loginRequest} from './auth/auth-config';
import { InteractionType } from '@azure/msal-browser';
import { getUserRole} from './utils/token';
import "@maersk-global/mds-react-wrapper/styles/core.css";
import './App.scss';
import MainContent from './Pages/ContainerSearchPage/ContainerSearchPage';

interface AppProps {
  msalInstance: PublicClientApplication;
}

const App: React.FC<AppProps> = ({ msalInstance }) => {
  const [userRole, setUserRole] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const authRequest = {
    ...loginRequest
  };
  const handleMSALMethods = async () => {
    const redirectResponse = await msalInstance.handleRedirectPromise();
    if (redirectResponse) {
      getUserRole().then((role) => {
        setUserRole(role);
        sessionStorage.setItem("userRole", role);
      });
    }
  }
  useEffect(() => {
    handleMSALMethods()
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest}>
         <MainContent msalInstance={msalInstance} />
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
};


export default App;

